import { jsx as o, jsxs as N } from "react/jsx-runtime";
import { c as p } from "./chunks/index.rKuIKazb.js";
import r from "react";
import { Flex as s } from "./flex.js";
import { IconButton as j } from "./icon-button.js";
import { L as _ } from "./chunks/layout.BROMuy9M.js";
import { Text as g } from "./text.js";
import { Icon as B } from "./icon.js";
import './assets/notification.css';const h = r.forwardRef(function(e, i) {
  return /* @__PURE__ */ o(j, { ref: i, variant: "ghost", mode: 200, ...e });
}), T = "_headline_y1ep4_3", H = {
  headline: T
}, w = r.forwardRef(({ children: t, className: e, ...i }, n) => {
  const c = p(H.headline, e);
  return /* @__PURE__ */ o(g, { variant: "p-100", className: c, ref: n, ...i, children: t });
});
w.displayName = "Notification.Headline";
const m = r.forwardRef(function({ icon: e, ...i }, n) {
  return /* @__PURE__ */ o(B, { ref: n, icon: e, color: "c-inverted", mode: 200, ...i });
}), v = r.forwardRef(({ children: t, ...e }, i) => /* @__PURE__ */ o(g, { variant: "cap-300", overflowWrap: "anywhere", ...e, ref: i, children: t }));
v.displayName = "Notification.Text";
const b = "_notification_18ogv_3", C = "_close_18ogv_18", a = {
  notification: b,
  "signal-warning": "_signal-warning_18ogv_9",
  "signal-error": "_signal-error_18ogv_12",
  "signal-success": "_signal-success_18ogv_15",
  close: C
}, l = ({
  icon: t,
  children: e,
  signal: i,
  className: n,
  open: c,
  onOpenChange: f,
  closeButton: u,
  ...y
}) => {
  const d = c !== void 0, [x, I] = r.useState(
    d ? c : !0
  ), R = p(
    a.notification,
    {
      [a[`signal-${i}`]]: i
    },
    n
  );
  return d && !c || !d && !x ? null : /* @__PURE__ */ o(s, { direction: "column", padding: 300, className: R, ...y, children: /* @__PURE__ */ N(s, { direction: "row", gap: 300, justifyContent: "space-between", children: [
    /* @__PURE__ */ N(s, { gap: 300, children: [
      t && /* @__PURE__ */ o(s, { className: a.icon, children: typeof t == "string" ? /* @__PURE__ */ o(m, { icon: t }) : t }),
      /* @__PURE__ */ o(
        s,
        {
          direction: "column",
          gap: 50,
          justifyContent: "center",
          alignItems: "baseline",
          width: "full",
          children: e
        }
      )
    ] }),
    u ? /* @__PURE__ */ o(_, { className: a.close, asChild: !0, children: u }) : /* @__PURE__ */ o(_, { className: a.close, asChild: !0, children: /* @__PURE__ */ o(
      h,
      {
        onClick: () => {
          f == null || f(!1), I(!1);
        },
        children: /* @__PURE__ */ o(m, { icon: "close-without-circle" })
      }
    ) })
  ] }) });
};
l.displayName = "Notification";
l.Headline = w;
l.Text = v;
l.Icon = m;
l.Button = h;
export {
  l as Notification
};
//# sourceMappingURL=notification.js.map
